var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _this = this;
export var isFunction = function (val) { return typeof val === "function"; };
export var isNumber = function (val) { return typeof val === "number"; };
export var isNumberLike = function (val) { return isNumber(val) ? true : isString(val) ? val.length > 0 && !isNaN(val) : false; };
export var isString = function (val) { return typeof val === "string"; };
export var isNull = function (val) { return val === null; };
export var isUndefined = function (val) { return val === undefined; };
export var isObject = function (val) { return !isNull(val) && typeof val === "object"; };
export var isPlainObject = function (val) { return isObject(val) && !isArray(val) && !isFunction(val); };
export var isArray = function (arr) { return Array.isArray(arr); };
export var isNode = function (val) {
    return typeof Node === "object"
        ? val instanceof Node
        : val && typeof val === "object" && typeof val.nodeType === "number" && typeof val.nodeName === "string";
};
export var isElement = function (val) {
    return typeof HTMLElement === "object"
        ? val instanceof HTMLElement
        : val && typeof val === "object" && val !== null && val.nodeType === 1 && typeof val.nodeName === "string";
};
export var formatPrice = function (price, decimal) {
    price = (Math.round(price * 100) / 100);
    var part = (price + "").split(".");
    return "&euro;&nbsp;" + part[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (decimal ? ("," + (part[1] === undefined ? "00" : (part[1].length < 2 ? part[1] + "0" : part[1]))) : "");
};
export var randomInt = function (min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 9999; }
    return Math.floor(Math.random() * (max - min)) + min;
};
export var randomDec = function (min, max, decimals) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 9999; }
    if (decimals === void 0) { decimals = 2; }
    return (Math.random() * (max - min) + min).toFixed(decimals);
};
export var randomList = function (list) {
    return list[randomInt(0, list.length)];
};
export var exec = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return isFunction(fn) ? fn.apply(_this, args) : undefined;
};
export var mapRange = function (value, source, target) { return target[0] + (value - source[0]) * (target[1] - target[0]) / (source[1] - source[0]); };
export var cleanString = function () {
    var x = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        x[_i] = arguments[_i];
    }
    return x.filter(function (x) { return typeof x === "string"; }).map(function (x) { return x.trim(); }).join(" ");
};
export var pause = function (ms) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var timeout = setTimeout(resolve, ms);
                return function () {
                    clearTimeout(timeout);
                    reject("pause canceled");
                };
            })];
    });
}); };
export var closest = function (element, selector) {
    if (Element.prototype.closest)
        return element.closest(selector);
    else {
        if (!Element.prototype.matches)
            Element.prototype.matches =
                Element.prototype["matchesSelector"] ||
                    Element.prototype["mozMatchesSelector"] ||
                    Element.prototype["msMatchesSelector"] ||
                    Element.prototype["oMatchesSelector"] ||
                    Element.prototype["webkitMatchesSelector"] ||
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
        do {
            if (element.matches(selector))
                return element;
            element = element.parentElement || element.parentNode;
        } while (element !== null && element.nodeType === 1);
        return null;
    }
};
export var animatePolygonPoints = function (element, from, to, bezier, duration) {
    if (duration === void 0) { duration = 500; }
    return new Promise(function (r) {
        var map = function (str) { return str.split(" ").map(function (x) { return x.split(",").map(function (x) { return parseFloat(x); }); }); };
        from = map(from);
        to = map(to);
        var state = from.map(function (x) { return []; });
        var delay = 25;
        var iterations = Math.round(duration / delay);
        var iteration = 0;
        var run = function () {
            var part = bezier(iteration++ / iterations);
            for (var i = 0; i < from.length; i++)
                for (var j = 0; j < from[i].length; j++)
                    state[i][j] = from[i][j] + ((to[i][j] - from[i][j]) * part);
            element.setAttribute("points", state.join(" "));
            if (part < 1)
                setTimeout(run, delay);
            else
                r();
        };
        run();
    });
};
export var getTransitionDuration = function (element, deep) {
    var duration = Math.max.apply(Math, (window.getComputedStyle(element).transitionDuration || "0").split(",").map(function (x) { return parseFloat(x); }));
    var delay = Math.max.apply(Math, (window.getComputedStyle(element).transitionDelay || "0").split(",").map(function (x) { return parseFloat(x); }));
    var totalTime = (duration + delay) * 1000;
    if (deep)
        totalTime += Array.from(element.children || []).reduce(function (sum, x) { return sum += getTransitionDuration(x, deep); }, 0);
    return totalTime;
};
export var replaceElement = function (html) {
    var id = getIdFromHTML(html);
    if (!id)
        throw new Error("no target id found in the given html");
    var target = document.getElementById(id);
    if (!target)
        throw new Error("no target id found for id " + id);
    return injectHTML(target, html);
};
export var getOuterHeight = function (element) {
    var styles = getComputedStyle(element);
    return parseFloat(styles.height || "0") +
        parseFloat(styles.marginTop || "0") +
        parseFloat(styles.marginBottom || "0") +
        parseFloat(styles.paddingTop || "0") +
        parseFloat(styles.paddingBottom || "0");
};
export var getOuterWidth = function (element) {
    var styles = getComputedStyle(element);
    return parseFloat(styles.width || "0") +
        parseFloat(styles.marginLeft || "0") +
        parseFloat(styles.marginRight || "0") +
        parseFloat(styles.paddingLeft || "0") +
        parseFloat(styles.paddingRight || "0");
};
export var scrollDirection = function (fn, delayed, scope) {
    if (delayed === void 0) { delayed = 0; }
    if (scope === void 0) { scope = null; }
    var prevDirections = [];
    var prev = 0;
    var element;
    return function () {
        var args = arguments;
        if (!element)
            element = args[0].currentTarget;
        var curr = element.pageYOffset || element.scrollTop;
        if (curr === prev)
            return;
        var direction = curr > prev ? 1 : -1;
        args[0].direction = direction;
        prev = curr;
        if (delayed) {
            prevDirections.push(direction);
            if (prevDirections.length > delayed)
                prevDirections.shift();
            if (prevDirections.length === delayed && prevDirections.every(function (x) { return x === prevDirections[0]; })) {
                fn.apply(scope, args);
            }
        }
        else {
            fn.apply(scope, args);
        }
    };
};
export var getOffsetsOnPage = function (element) {
    var _x = 0;
    var _y = 0;
    while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
        _x += element.offsetLeft - element.scrollLeft;
        _y += element.offsetTop - element.scrollTop;
        element = element.offsetParent;
    }
    return { top: _y, left: _x };
};
export var withinViewport = function (element) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
export var UUID = function () {
    var d = Date.now();
    if (window.performance && typeof window.performance.now === "function")
        d += performance.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
export var getIdFromHTML = function (html) {
    var matchedId = html.match(/id="([^"]*?)"/);
    return matchedId ? matchedId[1] : null;
};
export var injectHTML = function (placeholder, html) {
    var parent = placeholder.parentNode;
    var nextWrapper = document.createElement("div");
    nextWrapper.innerHTML = html;
    var next = [];
    for (var i = nextWrapper.children.length - 1; i >= 0; i--) {
        next.push(parent.insertBefore(nextWrapper.children[i], placeholder));
    }
    parent.removeChild(placeholder);
    return next;
};
export var pad = function (num, padlen, padchar) {
    if (padchar === void 0) { padchar = "0"; }
    var pad = new Array(1 + padlen).join(padchar);
    return (pad + num).slice(-pad.length);
};
export var msToS = function (ms) { return ms / 1000; };
export var sToMs = function (s) { return s * 1000; };
export var mToS = function (m) { return m * 60; };
export var sToM = function (s) { return s / 60; };
export var mToMs = function (m) { return sToMs(mToS(m)); };
export var msToM = function (ms) { return sToM(msToS(ms)); };
export var stingifyTime = function (ms, withMs) {
    var m = Math.floor(msToM(ms));
    ms -= mToMs(m);
    var s = withMs ? Math.floor(msToS(ms)) : Math.round(msToS(ms));
    ms -= sToMs(s);
    return pad(m, 2) + ":" + pad(s, 2) + (withMs ? ":" + pad(Math.floor(ms), 3) : "");
};
export var parseTime = function (duration) {
    var d = duration.split(":");
    return mToMs(parseInt(d[0], 10)) + sToMs(parseInt(d[1], 10)) + parseInt(d[2], 10);
};
export var uniqueArray = function (arr) { return Array.from(new Set(arr)); };
export var childOf = function (container, child) {
    var el = child;
    if (!el)
        return false;
    while (el !== container) {
        if (!el.parentNode)
            return false;
        el = el.parentNode;
    }
    return true;
};
export var getEventProps = function (e) {
    if (e.targetTouches && e.targetTouches[0])
        return e.targetTouches[0];
    if (e.changedTouches && e.changedTouches[0])
        return e.changedTouches[0];
    return e;
};
export var getOffsetX = function (e) {
    var x = 0;
    var elem = e.target;
    while (elem) {
        x += parseInt(elem.offsetLeft);
        elem = elem.offsetParent;
    }
    return getEventProps(e).pageX - x;
};
export var getOffsetY = function (e) {
    var y = 0;
    var elem = e.target;
    while (elem) {
        y += parseInt(elem.offsetTop);
        elem = elem.offsetParent;
    }
    return getEventProps(e).pageY - y;
};
export var doubletap = function (fn, threshold) {
    if (threshold === void 0) { threshold = 400; }
    var c = false;
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        if (c) {
            fn.apply(void 0, args);
            c = false;
        }
        else {
            c = true;
            t = setTimeout(function () { return c = false; }, threshold);
            args[0].redraw = false;
        }
    });
};
export var copyToClipboard = function (str) {
    try {
        var el = document.createElement("textarea");
        el.value = str;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        var selection = document.getSelection();
        var selected = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
        el.select();
        selection = document.getSelection();
        document.execCommand("copy");
        document.body.removeChild(el);
        if (selected) {
            selection.removeAllRanges();
            selection.addRange(selected);
        }
        return true;
    }
    catch (err) {
        return false;
    }
};
export var generateHashFromString = function (str) { return str.split("").reduce(function (prevHash, currVal) { return (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0; }, 0); };
export var findKey = function (obj, cb) {
    for (var k in obj)
        if (cb(obj[k], k, obj))
            return k;
    return undefined;
};
export var findObj = function (obj, cb) {
    var key = findKey(obj, cb);
    if (key === undefined)
        return undefined;
    return obj[key];
};
export var filterObj = function (obj, cb) {
    var result = {};
    for (var k in obj)
        if (cb(obj[k], k, obj))
            result[k] = obj[k];
    return result;
};
export var reduceObj = function (obj, cb, result) {
    for (var k in obj)
        result = cb(result, obj[k], k, obj);
    return result;
};
export var mapObj = function (obj, cb) {
    var result = {};
    for (var k in obj)
        result[k] = cb(obj[k], k, obj);
    return result;
};
export var groupObj = function (obj, key) {
    var result = {};
    for (var k in obj) {
        var gr = obj[k][key];
        if (result[gr] === undefined)
            result[gr] = [];
        result[gr].push(__assign({ $key: k }, obj[k]));
    }
    return result;
};
export var group = function (arr, key) {
    var result = {};
    for (var i = 0; i < arr.length; i++) {
        var gr = arr[i][key];
        if (result[gr] === undefined)
            result[gr] = [];
        result[gr].push(arr[i]);
    }
    return result;
};
export var repeat = function (times, cb) {
    for (var i = 0; i < times; i++)
        cb(i);
};
export var repeatMap = function (times, fn) {
    var result = [];
    for (var i = 0; i < times; i++)
        result[i] = fn(i);
    return result;
};
export var objectToArray = function (obj, key) {
    if (key === void 0) { key = "$key"; }
    return reduceObj(obj, function (r, x, k) {
        var _a;
        return r.concat(__assign(__assign({}, x), (_a = {}, _a[key] = k, _a)));
    }, []);
};
export var arrayToObject = function (arr, key) {
    if (key === void 0) { key = "$key"; }
    return arr.reduce(function (r, x) {
        var copy = __assign({}, x);
        delete copy[key];
        r[x[key]] = copy;
        return r;
    }, {});
};
export var increment = function () {
    var i = 0;
    return function () { return i++; };
};
export var diff = function (cb) {
    var x = cb();
    return function () { return cb() - x; };
};
export var debounce = function (fn, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        t = setTimeout(function () { return fn.apply(void 0, args); }, threshold);
    });
};
export var throttle = function (fn, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var p;
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        var now = Date.now();
        if (!p || now - p >= threshold) {
            p = now;
            fn.apply(void 0, args);
        }
        else {
            t = setTimeout(function () { return fn.apply(void 0, args); }, threshold);
        }
    });
};
export var partial = function (fn) {
    var argsBound = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        argsBound[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArrays([_this], argsBound, args));
    };
};
export var partialRight = function (fn) {
    var argsBound = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        argsBound[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArrays([_this], args, argsBound));
    };
};
export var curry = function (fn) { return function curried() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length >= fn.length)
        return fn.call.apply(fn, __spreadArrays([this], args));
    else
        return function () {
            var args2 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args2[_i] = arguments[_i];
            }
            return curried.call.apply(curried, __spreadArrays([_this], args, args2));
        };
}; };
export var hashString = function (str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash += Math.pow(str.charCodeAt(i) * 31, str.length - i);
        hash = hash & hash;
    }
    return hash;
};
export var fileToB64 = function (file) {
    return new Promise(function (res, rej) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return res(reader.result); };
        reader.onerror = function (err) { return rej(err); };
    });
};
export var formatSize = function (bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0)
        return "0 Byte";
    var i = Math.floor(Math.floor(Math.log(bytes) / Math.log(1024)));
    var size = (bytes / Math.pow(1024, i));
    size = Math.round(size * 100) / 100;
    return size + sizes[i];
};
export var createMap = function () { return ({
    store: {},
    get: function (uuid) {
        return this.store[uuid];
    },
    set: function (uuid, base64) {
        this.store[uuid] = base64;
    }
}); };
export var createToggle = function () { return ({
    value: false,
    on: function () { this.value = true; },
    off: function () { this.value = false; },
    toggle: function () { this.value = !this.value; }
}); };
export var removeIfExists = function (arr, value) {
    var i = arr.indexOf(value);
    if (i !== -1)
        arr.splice(i, 1);
    return arr;
};
export var createCanvas = function (dimensions) {
    var canvas = document.createElement("canvas");
    canvas.width = dimensions.width;
    canvas.height = dimensions.height;
    var ctx = canvas.getContext("2d");
    return { canvas: canvas, ctx: ctx };
};
export var createImage = function (src) {
    return new Promise(function (res, rej) {
        var img = new Image();
        img.onload = function () { return res(img); };
        img.onerror = function (err) { return rej(err); };
        img.src = src;
    });
};
export var crop = function (image, crop) {
    var _a = createCanvas(crop), canvas = _a.canvas, ctx = _a.ctx;
    ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    return canvas;
};
export var getRatio = function (dimensions) {
    return dimensions.width / dimensions.height;
};
export var getGFontsURL = function (html) {
    var matches = html.replace(/&quot;/g, "").match(/font-family: ?(.*?);/g);
    if (!matches)
        return "";
    var families = matches.map(function (x) {
        var f = x.replace(/ ?!important/, "");
        return f.substring(12, f.length - 1).trim();
    }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    var string = families.reduce(function (str, x, i) { return str += "" + (i > 0 ? "|" : "") + x; }, "").replace(/ /g, "+");
    return "<link href=\"https://fonts.googleapis.com/css?family=" + string + "\" rel=\"stylesheet\">";
};
export var sanitizeHTML = function (html) {
    var ta = document.createElement("textarea");
    ta.innerHTML = html;
    return (ta.value || html)
        .replace(/NS\d+:href/gi, 'xlink:href')
        .replace(/[\u00A0-\u9999\&]/gm, function (i) { return "&#" + i.charCodeAt(0) + ";"; });
};
export var memoize = function (fn, hashFn) {
    if (hashFn === void 0) { hashFn = function (args) { return JSON.stringify(args); }; }
    var cache = {};
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var hash = hashFn(args);
        if (!cache[hash])
            cache[hash] = fn.apply(void 0, args);
        return cache[hash];
    });
};
export var memoizeFixParams = function (fixParams, memoized) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return memoized.apply(void 0, fixParams.apply(void 0, args));
    });
};
export var filterFnUnique = function (keys) {
    return (function (x, i, a) {
        return a.findIndex(function (y) {
            return keys.every(function (k) { return y[k] === x[k]; });
        }) === i;
    });
};
export var matchesProperties = memoize(function (a, b, keys) {
    return (!a || !b)
        ? false
        : keys.every(function (x) {
            return a[x] === b[x];
        });
});
export var clone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
};
export var freeze = function (obj) {
    if (Object.isFrozen(obj))
        return obj;
    if (!Array.isArray(obj) && Object.getPrototypeOf(obj) !== Object.getPrototypeOf({}))
        return obj;
    Object.freeze(obj);
    Object.keys(obj)
        .forEach(function (x) { return freeze(obj[x]); });
    return obj;
};
export var findLikeIndex = function (arr, val) {
    return arr.findIndex(function (x) { return val.indexOf(x) !== -1; });
};
export var toNormalCase = function (str) {
    return Array.from(str).reduce(function (s, x, i) {
        return s + ((i > 0 && x === x.toUpperCase()) ? (" " + x.toLowerCase()) : x);
    }, "");
};
export var mmToPx = function (mm, dpi, round) {
    if (dpi === void 0) { dpi = 400; }
    var px = mm / 25.4 * dpi;
    return round ? Math.floor(px) : px;
};
export var getRootElements = function (selector, loaded) {
    var elements = Array.from(document.querySelectorAll(selector));
    if (!loaded)
        return elements;
    elements = elements.filter(function (x) { return !x.getAttribute("data-loaded"); });
    elements.forEach(function (x) { return x.setAttribute("data-loaded", "=D"); });
    return elements;
};
